import { IGetRegionResponse200 } from '../repositories/monolith-python/v1/get-region';
import { IRegion } from '../types/geoSwitcher';

export function prepareRegion({ response: { data: region } }: IGetRegionResponse200): IRegion {
  return {
    id: region.id,
    displayName: region.displayName,
    mainTownId: region.mainTownId || null,
    parentId: region.parentId || null,
    baseHost: region.baseHost || null,
  };
}
